
      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire0300"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire0300"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("b0TDZ", function(module, exports) {
// import * as THREE from "https://unpkg.com/three@0.155.0/build/three.module.js";
// =======================
// DOM
// =======================
const homepage = document.querySelector(".homepage");
const video = document.getElementById("homepageVideo");
if (!homepage || !video) {
    console.warn("Homepage or video not found");
    return;
}
// =======================
// THREE SETUP
// =======================
const scene = new THREE.Scene();
const camera = new THREE.OrthographicCamera(-1, 1, 1, -1, 0, 1);
const renderer = new THREE.WebGLRenderer({
    alpha: true,
    antialias: true
});
renderer.setSize(window.innerWidth, window.innerHeight);
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
homepage.appendChild(renderer.domElement);
// =======================
// VIDEO TEXTURE
// =======================
video.muted = true;
video.playsInline = true;
video.loop = true;
video.play();
const videoTexture = new THREE.VideoTexture(video);
videoTexture.minFilter = THREE.LinearFilter;
videoTexture.magFilter = THREE.LinearFilter;
videoTexture.format = THREE.RGBAFormat;
// =======================
// SHADER MATERIAL
// =======================
const material = new THREE.ShaderMaterial({
    uniforms: {
        uTexture: {
            value: videoTexture
        },
        uMouse: {
            value: new THREE.Vector2(0.5, 0.5)
        },
        uTime: {
            value: 0
        }
    },
    vertexShader: `
    varying vec2 vUv;
    void main() {
      vUv = uv;
      gl_Position = vec4(position, 1.0);
    }
  `,
    fragmentShader: `
    uniform sampler2D uTexture;
    uniform vec2 uMouse;
    uniform float uTime;
    varying vec2 vUv;

    void main()  {
  vec2 uv = vUv;

  // zone centrale (\u{2248} vid\xe9o)
  if (
    uv.x < 0.3 || uv.x > 0.7 ||
    uv.y < 0.3 || uv.y > 0.7
  ) {
    discard;
  }

  float d = distance(uv, uMouse);
  float ripple = 0.012 * sin(18.0 * d - uTime * 4.0);
  uv += ripple * normalize(uv - uMouse);

  gl_FragColor = texture2D(uTexture, uv);
}
  `,
    transparent: true
});
// =======================
// PLANE
// =======================
const plane = new THREE.Mesh(new THREE.PlaneGeometry(2, 2), material);
scene.add(plane);
// =======================
// INTERACTIONS
// =======================
function updatePointer(x, y) {
    material.uniforms.uMouse.value.set(x / window.innerWidth, 1 - y / window.innerHeight);
}
// Desktop
window.addEventListener("mousemove", (e)=>{
    updatePointer(e.clientX, e.clientY);
});
// Mobile
window.addEventListener("touchmove", (e)=>{
    const touch = e.touches[0];
    updatePointer(touch.clientX, touch.clientY);
}, {
    passive: true
});
// =======================
// ANIMATION LOOP
// =======================
function animate(time) {
    material.uniforms.uTime.value = time * 0.001;
    renderer.render(scene, camera);
    requestAnimationFrame(animate);
}
animate(0);
// =======================
// RESIZE
// =======================
window.addEventListener("resize", ()=>{
    renderer.setSize(window.innerWidth, window.innerHeight);
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
});

});


parcelRequire("b0TDZ");

//# sourceMappingURL=index.14cde73b.js.map
